import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// helpers
import get from 'lodash.get';

function PdpSharedDetailManufactureDate({ item }) {
    return (
        <span data-tn="pdp-spec-date-of-manufacture">
            {get(item, 'classification.creationDate')}
        </span>
    );
}

PdpSharedDetailManufactureDate.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailManufactureDate, {
    item: graphql`
        fragment PdpSharedDetailManufactureDate_item on Item {
            classification {
                creationDate
            }
        }
    `,
});
